<div *ngIf="isStepOne">
  <form novalidate [formGroup]="editForm">
    <div class="col-md-4 offset-md-3" style="width: 100%;">
      <div style="margin:25px auto;">
        <div class="form-group">
          <label for="userName" class="control-label">Enter the account User Name for which you need a password reset</label>
          <input type="text" class="k-textbox" style="width: 100%;" formControlName="userName" />
        </div>
        <button type="button" class="btn btn-primary" [disabled]='!editForm.valid' (click)="onSendRequest()">Send Request</button>
      </div>
    </div>
  </form>
</div>
<div *ngIf="!isStepOne">
  <form novalidate [formGroup]="editForm2">
    <div class="col-md-4 offset-md-3" style="width: 100%;">
      <div style="margin:25px auto;">
        <p>Check the email of account {{ this.username }} for a password reset code and enter it below.</p>
        <div class="form-group">
          <label for="passwordResetCode">Password Reset Code</label>
          <input type="text" class="k-textbox" style="width:100%;" formControlName="passwordResetCode" />
        </div>
        <div *ngIf="editForm2.controls.passwordResetCode.invalid && (editForm2.controls.passwordResetCode.dirty || editForm2.controls.passwordResetCode.touched)"
              class="form-control-feedback" style="color:red;">
          <p *ngIf="editForm2.controls.passwordResetCode.errors.required">
            Password Reset Code is required.
          </p>
        </div>
        <div class="form-group">
          <label for="proposedPassword">New Password</label>
          <input type="password" class="k-textbox" style="width:100%;" formControlName="proposedPassword" />
        </div>
        <div *ngIf="editForm2.controls.proposedPassword.invalid && (editForm2.controls.proposedPassword.dirty || editForm2.controls.proposedPassword.touched)"
              class="form-control-feedback" style="color:red;">
          <p *ngIf="editForm2.controls.proposedPassword.errors.required">
            Password is required.
          </p>
          <p *ngIf="editForm2.controls.proposedPassword.errors.minlength">
            Password must be at least 8 characters long.
          </p>
          <p *ngIf="editForm2.controls.proposedPassword.errors.pattern">
            Password must have at least one uppercase and one lowercase character, one number and one special character &#40; &#94;$ * . [ ] &#123; &#125; &#40; &#41; ? &quot; ! &#64; # % &amp; / \ , &gt; &lt; ' : ; | _ ~ `&#41;
          </p>
        </div>
        <div class="form-group">
          <label for="confirmPassword">Confirm New Password</label>
          <input type="password" class="k-textbox" style="width:100%;" formControlName="confirmPassword" />
        </div>
        <div *ngIf="(editForm2.controls.confirmPassword.errors || editForm2.errors?.mismatch) && (editForm2.controls.confirmPassword.dirty || editForm2.controls.confirmPassword.touched)"
              class="form-control-feedback">
          <span *ngIf="editForm2.controls.confirmPassword.errors || editForm2.errors?.mismatch" style="color: red;">
            Passwords must match
          </span>
        </div>
        <div class="row" style="display:flex; justify-content:center;">
          <div>
            <input type="button" class="btn btn-primary" value="Reset Password" [disabled]='!editForm2.valid' (click)="onResetPassword()">
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
